// Central content + imagery for Losta Group. Marketing copy is intentionally
// placeholder-free of invented figures (no fake CA, counts, acquisitions).

export const IMAGES = {
  heroMain: "https://static.prod-images.emergentagent.com/jobs/1ec17bad-dc8f-4fe5-b880-3f77f661c4f6/images/8f1bc7bc3df3fb7b506964bc87c1b7deed14a9ac8557fa4afac3f5092c69762a.jpeg",
  heroAlt: "https://images.unsplash.com/photo-1593106410288-caf65eca7c9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  welding: "https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  workshop: "https://images.unsplash.com/photo-1633155570430-4352fe7b6835?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  swiss: "https://images.unsplash.com/photo-1584200463394-bba4b2117e4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facade: "https://images.unsplash.com/photo-1601364532643-4857e5dc7617?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glass: "https://images.unsplash.com/photo-1623051786552-e46ef84e6c07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { label: "Accueil", to: "/" },
  { label: "Le Groupe", to: "/groupe" },
  { label: "Notre Stratégie", to: "/strategie" },
  { label: "Nos Métiers", to: "/metiers" },
  { label: "Critères d'Acquisition", to: "/acquisitions" },
  { label: "Céder votre entreprise", to: "/ceder-votre-entreprise" },
  { label: "Nos Sociétés", to: "/societes" },
  { label: "Contact", to: "/contact" },
];

export const SECTORS = [
  {
    slug: "enseignes-signaletique",
    n: "01",
    title: "Enseignes & Signalétique",
    short: "Enseignes lumineuses, LED, lettres boîtiers, totems, wayfinding et habillage de façades.",
    img: "/losta-enseigne.jpg",
    items: ["Enseignes lumineuses", "Enseignes LED", "Lettres boîtiers", "Caissons lumineux", "Totems", "Signalétique intérieure", "Signalétique extérieure", "Wayfinding", "Signalétique architecturale", "Plaques professionnelles", "Habillage de façades", "Maintenance d'enseignes"],
  },
  {
    slug: "communication-visuelle",
    n: "02",
    title: "Communication Visuelle",
    short: "PLV, displays, décoration, habillage et communication de points de vente.",
    img: "/losta-totem.jpg",
    items: ["Communication visuelle", "PLV", "Displays", "Décoration", "Habillage", "Signalétique événementielle", "Stands", "Communication de points de vente"],
  },
  {
    slug: "impression-numerique",
    n: "03",
    title: "Impression Numérique",
    short: "Grand format, UV, sérigraphie, textile, découpe CNC et gravure.",
    img: "https://images.unsplash.com/photo-1693031630369-bd429a57f115?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Impression grand format", "Impression UV", "Sérigraphie", "Impression textile", "Découpe numérique", "Découpe CNC", "Gravure", "Production graphique"],
  },
  {
    slug: "marquage-adhesif-covering",
    n: "04",
    title: "Marquage Adhésif & Covering",
    short: "Covering automobile et architectural, vitrophanie, PPF, wrapping et marquage de flottes.",
    img: "https://images.unsplash.com/photo-1646531840695-62810bcd1171?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Marquage adhésif", "Pose d'adhésifs", "Covering automobile", "Covering architectural", "Covering mobilier", "Marquage de véhicules", "Marquage de flottes", "Vitrophanie", "Décoration de vitrines", "Films dépolis", "PPF", "Wrapping", "Marquage au sol"],
  },
  {
    slug: "smart-glass",
    n: "05",
    title: "Smart Glass & Films Techniques",
    short: "Films PDLC, verre intelligent, occultation électrique et solutions de confidentialité.",
    img: "https://images.unsplash.com/photo-1748764720733-3bb4c52ab6f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Smart Glass", "Films PDLC", "Verre intelligent", "Films pour vitrages", "Films solaires", "Films de sécurité", "Films décoratifs", "Occultation électrique", "Cloisons vitrées techniques", "Solutions de confidentialité"],
  },
  {
    slug: "metallerie-serrurerie",
    n: "06",
    title: "Métallerie & Serrurerie",
    short: "Tôlerie, chaudronnerie, découpe laser, soudure, structures métalliques et thermolaquage.",
    img: "https://images.unsplash.com/photo-1532186773960-85649e5cb70b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Métallerie", "Serrurerie", "Tôlerie", "Chaudronnerie légère", "Découpe laser", "Pliage", "Soudure", "Usinage", "Aluminium", "Acier", "Inox", "Structures métalliques", "Thermolaquage", "Peinture industrielle"],
  },
  {
    slug: "eclairage-led",
    n: "07",
    title: "Éclairage & Technologies LED",
    short: "Néon LED, éclairage architectural, croix de pharmacie, écrans et affichage dynamique.",
    img: "https://images.unsplash.com/photo-1561794919-75618574e915?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Éclairage LED", "Néon LED", "Éclairage architectural", "Croix de pharmacie", "Affichage dynamique", "Écrans LED", "Solutions digitales points de vente"],
  },
  {
    slug: "portails-fermetures",
    n: "08",
    title: "Portails & Fermetures",
    short: "Portails, clôtures, garde-corps, pergolas, motorisations et contrôle d'accès.",
    img: "https://images.unsplash.com/photo-1645005049035-c35644b627ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Portails", "Clôtures", "Portillons", "Brise-vues", "Garde-corps", "Pergolas", "Carports", "Motorisations", "Automatismes", "Contrôle d'accès"],
  },
  {
    slug: "activites-complementaires",
    n: "09",
    title: "Activités Complémentaires",
    short: "Agencement commercial, menuiserie aluminium, maintenance multiservice et mobilier sur mesure.",
    img: "https://images.unsplash.com/photo-1633155570430-4352fe7b6835?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: ["Agencement commercial", "Aménagement de points de vente", "Menuiserie aluminium", "Maintenance multiservice", "Pose technique", "Électricité basse tension", "Mobilier commercial", "Fabrication sur mesure"],
  },
];

export const CRITERIA = [
  { n: "01", title: "Savoir-faire", text: "Une expertise technique, des compétences et une véritable connaissance métier." },
  { n: "02", title: "Clientèle", text: "Une clientèle professionnelle ou particulière établie et fidèle." },
  { n: "03", title: "Équipe", text: "Des collaborateurs possédant les compétences permettant de poursuivre et développer l'activité." },
  { n: "04", title: "Potentiel", text: "Un potentiel de croissance grâce aux investissements et aux synergies du groupe." },
  { n: "05", title: "Implantation", text: "Une présence géographique permettant de construire un maillage territorial en France et en Suisse." },
];

export const PROCESS = [
  { n: "01", title: "Échange confidentiel", text: "Un premier contact direct, discret et sans engagement." },
  { n: "02", title: "Étude", text: "Analyse du savoir-faire, des équipes et du potentiel de développement." },
  { n: "03", title: "Rencontre", text: "Une rencontre pour comprendre votre histoire et vos attentes." },
  { n: "04", title: "Proposition", text: "Une proposition construite et adaptée à votre projet." },
  { n: "05", title: "Transmission", text: "Une opération structurée dans une logique de continuité." },
  { n: "06", title: "Développement", text: "De nouveaux moyens et des synergies pour accélérer la croissance." },
];

export const PHILOSOPHY = [
  { title: "Préserver", text: "L'histoire, les équipes, les clients et les compétences." },
  { title: "Mutualiser", text: "Les achats, les technologies, les équipements et certaines capacités de production." },
  { title: "Partager", text: "Les opportunités commerciales et les compétences entre les sociétés du groupe." },
  { title: "Investir", text: "Dans les machines, les équipes, le digital et les nouvelles technologies." },
  { title: "Développer", text: "De nouveaux marchés, de nouvelles implantations et de nouvelles compétences." },
];

export const ECOSYSTEM = ["Compétences", "Production", "Technologies", "Achats", "Clients", "Opportunités", "Expérience", "Ressources"];

export const TRANSMISSION_TYPES = [
  "Transmission totale",
  "Transmission progressive",
  "Recherche d'un partenaire",
  "Succession",
  "Autre",
];

export const SECTOR_OPTIONS = SECTORS.map((s) => s.title);

// Group organisation (holding -> sociétés -> marques). Client-provided structure.
export const ORG = {
  holding: "Losta Group",
  poles: [
    {
      country: "Suisse",
      flag: "🇨🇭",
      company: "Luxury Signs Sàrl",
      companyWebsite: "https://www.luxurysigns.ch",
      brands: [
        { name: "Genève Enseigne", desc: "Enseignes lumineuses & signalétique.", website: "https://www.geneveenseigne.ch" },
        { name: "SignaPharma Suisse", desc: "Solutions dédiées aux pharmacies.", website: "https://www.signapharma.ch" },
        { name: "Smart X Glass Suisse", desc: "Vitrages intelligents & films PDLC.", website: "https://www.smartxglass.ch" },
        { name: "Portail du Léman Suisse", desc: "Fermetures & aménagement extérieur.", website: "https://www.portailduleman.ch" },
      ],
    },
    {
      country: "France",
      flag: "🇫🇷",
      company: "Losta Tech SAS",
      companyWebsite: "",
      brands: [
        { name: "Rhône-Alpes Enseigne", desc: "Communication visuelle & signalétique.", website: "" },
        { name: "SignaPharma France", desc: "Identité visuelle des pharmacies.", website: "https://www.signapharma.fr" },
        { name: "Smart X Glass France", desc: "Smart Glass & films techniques.", website: "" },
        { name: "Portail du Léman France", desc: "Fermetures & aménagement extérieur.", website: "https://www.portailduleman.fr" },
      ],
    },
  ],
};

export const SEO_KEYWORDS = [
  "rachat entreprise communication visuelle", "cession entreprise enseigne", "vendre entreprise signalétique",
  "reprise imprimerie numérique", "rachat société covering", "cession entreprise métallerie",
  "rachat entreprise smart glass", "transmission entreprise Suisse", "reprise PME France", "repreneur entreprise",
];
